module.exports = __webpack_public_path__ + "static/img/start_btn@2x.e51d310.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scriptInfos/start_btn@2x.png
// module id = Rlyy
// module chunks = 23